import { AppDispatch, AppState, AppThunkDispatch } from 'src/store';
import { getScopeReadyData, getScopeId, isReady } from '../../../state/scope/Scope.types';

import { RightContainerPayloadType } from 'src/components/RightContainer/RightContainer';
import { MfpSubheaderValueProps } from './MfpSubheader';
import { setRightContainerPayload, toggleRightContainer } from 'src/components/RightContainer/RightContainer.slice';
import { refreshCurrentMfpScope } from 'src/state/scope/Scope.actions';

const getCurrentSubheaderBtns = (state: AppState): string[] | undefined => {
  const currentViewComponentProps =
    state.perspective.activePageConf && (state.perspective.activePageConf.componentProps as any); //TO DO: Fix this type later on

  if (
    !currentViewComponentProps ||
    !currentViewComponentProps.subheader ||
    !currentViewComponentProps.subheader.extraBtns
  ) {
    return undefined;
  }
  return currentViewComponentProps.subheader.extraBtns;
};
export function mapStateToProps(state: AppState): MfpSubheaderValueProps {
  const readyScope = getScopeReadyData(state.mfpScope);
  const id = getScopeId(state.mfpScope);

  const activeExtraBtns = getCurrentSubheaderBtns(state);
  if (!readyScope || !id) {
    return {
      hasEditableRevision: false,
      activeExtraBtns,
      commentsOpen:
        state.rightContainer.payload?.type === RightContainerPayloadType.Comments && state.rightContainer.open,
    };
  }

  const hasEditableRevision = readyScope.hasEditableRevision;
  return {
    hasEditableRevision,
    activeExtraBtns,
    commentsOpen:
      state.rightContainer.payload?.type === RightContainerPayloadType.Comments && state.rightContainer.open,
  };
}

export const mapDispatchToProps = (dispatch: AppThunkDispatch, getState: () => AppState) => {
  return {
    toggleRightContainer: () => {
      dispatch(setRightContainerPayload({ type: RightContainerPayloadType.Comments }));
      dispatch(toggleRightContainer());
    },
    refreshCurrentScope: () => {
      return dispatch(() => {
        return dispatch(refreshCurrentMfpScope());
      });
    },
  };
};
export interface MfpSubheaderDispatchProps extends ReturnType<typeof mapDispatchToProps> {}
